<template>
  <div class="form-renderer-root" style="display: contents">
    <div
      v-for="(field, idx) in visibleFields"
      :key="field.key || idx"
      :class="ctx.getContainerClass(field, { multiple, subform })"
      :style="field.type === 'group' && !ctx.canEditVisualGroup(field) ? 'display: none;' : ''"
    >
      <div v-if="field.type !== 'button'">
        <div
          v-if="field.type === 'group' && ctx.getVisualGroupType(field.key) === 'box'"
          class=""
        >
          <label class="form-label cursor-pointer p-2 text-secondary">
            <GroupIcon v-if="field.icon" :icon="field.icon" />
            {{ $t(field.label) }}
          </label>
        </div>
        <div
          v-if="field.type == 'group' && (ctx.getVisualGroupType(field.key) === 'fieldset' ) && !field.isArray"
          class="col-md-12 p-0"
          :class="field.key"
        >
          <label
            :for="fieldId(field)"
            :data-focus-id="groupFocusId(field)"
            class="form-label cursor-pointer w-100 dyn-group-header"
            :class="ctx.getClassFieldset(field, basePath)"
            @click="ctx.open === fullPath(field) ? ctx.setOpen(basePath) : ctx.setOpen(fullPath(field))"

            v-if="!isSubGroup(field)"
          >
            <GroupIcon v-if="field.icon" :icon="field.icon" />
            <i v-else class="material-icons" >{{ field.label2 }}</i>
            {{ $t(field.label) }}
          </label>
       
        </div>
        <small
          v-else
          :for="fieldId(field)"
          class="form-label w-100 text-secondary position-relative"
          :class="ctx.getValue(fullPath(field)) ? 'text-primary' : 'text-secondary'"
        >
          <!-- El reference dibuja su label junto a lupa/agregar/editar. -->
          <template v-if="field.type !== 'group' && field.type !== 'reference'">
            <span>{{ $t(field.label) }}</span>
            <!-- Al costado del label, no en el renglón de abajo. -->
            <span v-if="field.required" class="text-danger ms-1">* required</span>
          </template>
        </small>
        <small
          class="text-danger"
          v-if="field.required && field.type === 'group'"
        >* required <br/></small>
        <div v-if="field.tooltip && !isSubGroup(field) && !field.isArray">
          <small class="text-danger">
            <i class="fas fa-info-circle"></i> {{ field.tooltip }}
          </small>
        </div>
      </div>

      <!-- Select -->
      <FieldSelect
        v-if="field.type === 'select'"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @update:editingFields="(v) => ctx.setEditingFields(v)"
      />

      <!-- Array of primitives -->
      <div
        v-else-if="field.isArray && ['string','number','boolean','date','email'].includes(field.type)"
        :class="field.type === 'group' && field.isArray ? 'group-multiple' : ''"
      >
        <table class="table table-sm PEPE">
          <thead>
            <tr>
              <th>{{ $t(field.label) }}</th>
              <th style="width: 100px"></th>
            </tr>
          </thead>
            <tbody>
            <tr v-for="(item, arrIdx) in getArrayForIteration(field)" :key="arrIdx">
              <td>
                <FieldText
                  v-if="['string','text','email'].includes(field.type)"
                  :field="field"
                  :value="ctx.getValue(pathIdx(field, arrIdx))"
                  mode="edit"
                  :fieldId="fieldIdIdx(field, arrIdx)"
                  :editingFields="field.safe && ctx.editingFields !== field.key ? '' : field.key"
                  :showLabel="false"
                  :calculated="isCalculated(pathIdx(field, arrIdx))"
                  @input="(val) => ctx.setValue(pathIdx(field, arrIdx), val)"
                  @update:editingFields="ctx.setEditingFields($event)"
                />
                <FieldNumber
                  v-else-if="field.type === 'number'"
                  :field="field"
                  :value="ctx.getValue(pathIdx(field, arrIdx))"
                  mode="edit"
                  :fieldId="fieldIdIdx(field, arrIdx)"
                  :editingFields="field.safe && ctx.editingFields !== field.key ? '' : field.key"
                  :parentItem="ctx.getState()"
                  :showLabel="false"
                  :calculated="isCalculated(pathIdx(field, arrIdx))"
                  @input="(val) => ctx.setValue(pathIdx(field, arrIdx), val)"
                  @update:editingFields="ctx.setEditingFields($event)"
                />
                <FieldBoolean
                  v-else-if="field.type === 'boolean'"
                  :field="field"
                  :value="ctx.getValue(pathIdx(field, arrIdx))"
                  mode="edit"
                  :fieldId="fieldIdIdx(field, arrIdx)"
                  :editingFields="field.safe && ctx.editingFields !== field.key ? '' : field.key"
                  :showLabel="false"
                  :calculated="isCalculated(pathIdx(field, arrIdx))"
                  @input="(val) => ctx.setValue(pathIdx(field, arrIdx), val)"
                  @update:editingFields="ctx.setEditingFields($event)"
                />
                <FieldDate
                  v-else-if="field.type === 'date'"
                  :field="field"
                  :value="ctx.getValue(pathIdx(field, arrIdx))"
                  mode="edit"
                  :fieldId="fieldIdIdx(field, arrIdx)"
                  :editingFields="field.safe && ctx.editingFields !== field.key ? '' : field.key"
                  :showLabel="false"
                  :calculated="isCalculated(pathIdx(field, arrIdx))"
                  @input="(val) => ctx.setValue(pathIdx(field, arrIdx), val)"
                  @update:editingFields="ctx.setEditingFields($event)"
                />
              </td>
              <td class="text-center">
                <button type="button" class="btn btn-sm btn-danger" @click="ctx.removeArrayItem(fullPath(field), arrIdx)">
                  <i class="material-icons">delete</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="mt-2">
          <button type="button" class="btn btn-sm btn-secondary" @click="addPrimitiveArrayItem(field)">
            <i class="material-icons">add</i> {{ $t('add') }}
          </button>
        </div>
      </div>

      <!-- Reference -->
      <FieldReference
        v-else-if="field.type === 'reference' && field.ref && !field.hide"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        mode="edit"
        :inlineLabel="$t(field.label)"
        :inlineLabelRequired="!!field.required"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :referenceOptions="ctx.referenceOptions[field.key] || []"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @update:editingFields="(v) => ctx.setEditingFields(v)"
        @open-reference-modal="ctx.openReferenceModal"
      />

      <!-- String / text / email / textarea -->
      <FieldText
        v-else-if="(field.type === 'string' || field.type === 'text') && !field.isArray"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        :valuePath="fullPath(field)"
        :localeValues="localeValuesFor(field)"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @sibling-input="onSiblingInput"
        @update:editingFields="ctx.setEditingFields($event)"
      />
      <FieldText
        v-else-if="field.type === 'email' && !field.isArray"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        :valuePath="fullPath(field)"
        :localeValues="localeValuesFor(field)"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @sibling-input="onSiblingInput"
        @update:editingFields="ctx.setEditingFields($event)"
      />
      <!-- textarea + field.html → CKEditor en EditFieldText (no hace falta tocar FormV2) -->
      <FieldText
        v-else-if="field.type === 'textarea' && !field.isArray"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        :valuePath="fullPath(field)"
        :localeValues="localeValuesFor(field)"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @sibling-input="onSiblingInput"
        @update:editingFields="ctx.setEditingFields($event)"
      />

      <!-- Date -->
      <FieldDate
        v-else-if="field.type === 'date' && !field.isArray"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @update:editingFields="(v) => ctx.setEditingFields(v)"
      />

      <!-- Number -->
      <FieldNumber
        v-else-if="field.type === 'number' && !field.isArray"
        :field="field"
        :value="ctx.getValue(fullPath(field)) != null ? ctx.getValue(fullPath(field)) : field.defaultValue"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @update:editingFields="(v) => ctx.setEditingFields(v)"
      />

      <!-- AutoIncrement -->
      <AutoIncrementField
        v-else-if="field.type === 'autoincrement'"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        :modelName="ctx.selectedModel"
        :required="field.required"
        :readonly="field.readonly"
        :editingFields="ctx.editingFields"
        @input="onAutoIncrementInput(field, $event)"
        @invoice-number-preview="onInvoiceNumberPreview"
        @update:editingFields="onAutoIncrementEditingFields"
        @updateDateField="onAutoIncrementUpdateDateField"
      />

      <!-- Boolean -->
      <FieldBoolean
        v-else-if="field.type === 'boolean' && ctx.getState()"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @update:editingFields="(v) => ctx.setEditingFields(v)"
      />

      <!-- Button -->
      <FormInput
        v-else-if="field.type === 'button' && !field.hide"
        :field="field"
        :formData="ctx.getState()"
        :value="ctx.getValue(fullPath(field))"
        :fieldId="fieldId(field)"
        @button-click="(val) => $emit('button-click', val)"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        :lock="field.safe && ctx.editingFields !== field.key"
      />

      <!-- Image -->
      <FieldImage
        v-else-if="field.type === 'image'"
        :value="ctx.getValue(fullPath(field))"
        :field="field"
        :fieldId="fieldId(field)"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @pending-file="(file) => $emit('pending-file', { key: field.key, file })"
        @pending-files="(files) => $emit('pending-files', { key: field.key, files })"
        @remove-pending-file="(index) => $emit('remove-pending-file', { key: field.key, index })"
      />

      <!-- Group (not array) -->
      <div
        v-else-if="field.type === 'group' && !field.isArray"
        :id="fieldId(field)"
        class="tabs-group float-left w-100 row m-0"
        :class="ctx.getBoxClass(field.key, basePath)"
      >
        <FormRenderer
          :fields="field.fields || []"
          :base-path="fullPath(field)"
          :id-prefix="fieldId(field)"
          :subform="true"
          :multiple="false"
          @button-click="$emit('button-click', $event)"
        />
      </div>

      <!-- Group array -->
      <div
        v-else-if="field.isArray && field.type === 'group'"
        :id="fieldId(field)"
        class="float-left  w-100 mb-4"
        :class="(ctx.open === fullPath(field) || ctx.open?.startsWith(fullPath(field) + '.') || isSubGroup(field) || (field.isArray && field.type === 'group')) ? 'd-block  ' : 'd-none'"
      >
        <div :class="field.type === 'group' && field.isArray ? 'group-multiple' : ''">
          <div class="table table-sm mt-3 dyn-array-block">
            <h6 class="dyn-array-title text-primary">{{ field.label }}</h6>
            <div v-if="field.tooltip">
              <small class="text-danger">
                <i class="fas fa-info-circle"></i> {{ field.tooltip }}
              </small>
            </div>
            <div>
              <!-- Una fila por ítem: flex en vez de floats, así no se escalona cuando
                   las celdas tienen distinta altura y la línea entra entera. -->
              <div
                v-for="(item, arrIdx) in getArrayForIteration(field)"
                :key="arrIdx"
                :id="fieldId(field) + '-' + (arrIdx + 1)"
                class="w-100 border border-primary rounded dyn-array-row"
              >
                <div
                  v-for="subField in ctx.visibleGroupFields(field)"
                  :key="subField.key"
                  class="dyn-array-cell"
                  :class="[
                    'dyn-array-cell--' + subField.type,
                    subField.type === 'group' ? 'dyn-array-cell--block' : '',
                  ]"
                >
                  <!-- Un grupo anidado ya trae su propio título y el reference
                       dibuja el suyo al lado de sus botones: repetirlo sobraba. -->
                  <small
                    v-if="subField.type !== 'group' && subField.type !== 'reference'"
                    class="dyn-array-cell-label"
                  >
                    <strong>{{ $t(subField.label) }}</strong>
                    <span v-if="subField.required" class="text-danger">* required</span>
                  </small>
                  <FormRenderer
                    :fields="[subField]"
                    :base-path="fullPath(field) + '.' + arrIdx"
                    :id-prefix="fieldId(field) + '-' + (arrIdx + 1)"
                    :subform="true"
                    :multiple="true"
                    @button-click="$emit('button-click', $event)"
                  />
                </div>
                <div class="text-center dyn-array-row-actions">
                  <button
                    type="button"
                    class="btn btn-sm btn-danger remove-row"
                    :disabled="
                      ctx.selectedModel === 'shipping' &&
                      item &&
                      item.payments &&
                      item.payments.length > 0
                    "
                    @click="ctx.removeArrayItem(fullPath(field), arrIdx)"
                  >
                    <i class="material-icons">close</i>
                  </button>
                  <span
                    v-if="
                      ctx.selectedModel === 'shipping' &&
                      item &&
                      item.payments &&
                      item.payments.length > 0
                    "
                    class="text-danger d-block small"
                  >
                    {{ item.payments.length }}
                    payments applied
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-sm btn-primary mt-2 px-3" @click="addGroupArrayItem(field)">
          {{ field.groupAddLineLabel ? $t(field.groupAddLineLabel) : '+' }}
        </button>
      </div>

      <!-- List -->
      <FieldList
        v-else-if="field.type === 'list' && field.listType"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :lists="ctx.lists"
        :option-id-filter="listOptionFilterFor(field)"
        :record-item="recordItemAtCurrentPath()"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @update:editingFields="(v) => ctx.setEditingFields(v)"
      />

      <!-- TextList -->
      <FieldTextList
        v-else-if="field.type === 'textlist'"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :modelName="ctx.selectedModel"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @update:editingFields="(v) => ctx.setEditingFields(v)"
      />

      <!-- Icon -->
      <FieldIcon
        v-else-if="field.type === 'icon'"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :defaultIcons="ctx.defaultIcons"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @update:editingFields="(v) => ctx.setEditingFields(v)"
      />

      <!-- File -->
      <FieldFile
        v-else-if="field.type === 'file'"
        :field="field"
        :value="ctx.getValue(fullPath(field))"
        mode="edit"
        :fieldId="fieldId(field)"
        :editingFields="ctx.editingFields"
        :showLabel="false"
        :calculated="isCalculated(fullPath(field))"
        @input="(val) => ctx.setValue(fullPath(field), val)"
        @update:editingFields="(v) => ctx.setEditingFields(v)"
      />
    </div>
  </div>
</template>

<script>
import GroupIcon from "@/components/gotrading/common/GroupIcon.vue";
import FormInput from "./FormInput.vue";
import AutoIncrementField from "./AutoIncrementField.vue";
import FieldImage from "../fields/FieldImage.vue";
import {
  FieldText,
  FieldNumber,
  FieldList,
  FieldReference,
  FieldDate,
  FieldBoolean,
  FieldSelect,
  FieldFile,
  FieldTextList,
  FieldIcon,
} from "../model-definition-core";
import FormRenderer from "./FormRenderer.vue";
import {
  getFieldTranslatableLocales,
  getLocaleSiblingPath,
  isFieldTranslatable,
} from "@/utils/fieldValueI18n";

export default {
  name: "FormRenderer",
  components: {
    GroupIcon,
    FormInput,
    AutoIncrementField,
    FieldImage,
    FieldText,
    FieldNumber,
    FieldList,
    FieldReference,
    FieldDate,
    FieldBoolean,
    FieldSelect,
    FieldFile,
    FieldTextList,
    FieldIcon,
    FormRenderer,
  },
  inject: {
    formContext: { default: null },
  },
  props: {
    fields: { type: Array, default: () => [] },
    basePath: { type: String, default: "" },
    idPrefix: { type: String, default: "" },
    subform: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
  },
  computed: {
    ctx() {
      return this.formContext || {};
    },
    visibleFields() {
      return (this.fields || []).filter((f) => !f.hide);
    },
  },
  methods: {
    isSubGroup(field) {
      return this.subform && field?.type === "group" && field?.isArray;
    },
    /** Return array to iterate in v-for using only numeric indices (0,1,2...). Avoids "N" from rules so we never use basePath with .N. */
    getArrayForIteration(field) {
      const path = this.fullPath(field);
      const val = this.ctx.getValue ? this.ctx.getValue(path) : undefined;
      if (Array.isArray(val)) return val;
      if (val && typeof val === "object" && !Array.isArray(val)) {
        const numericKeys = Object.keys(val).filter((k) => /^\d+$/.test(k)).sort((a, b) => Number(a) - Number(b));
        return numericKeys.map((k) => val[k]);
      }
      return [];
    },
    fullPath(field) {
      return this.basePath ? `${this.basePath}.${field.key}` : field.key;
    },
    fieldId(field) {
      return this.ctx.getFieldId ? this.ctx.getFieldId(this.fullPath(field), this.idPrefix) : this.fullPath(field);
    },
    groupFocusId(field) {
      if (!field || field.type !== "group" || !field.key) return null;
      return `group-${String(field.key).toLowerCase()}`;
    },
    pathIdx(field, idx) {
      return `${this.fullPath(field)}.${idx}`;
    },
    fieldIdIdx(field, idx) {
      return this.ctx.getFieldId ? this.ctx.getFieldId(this.pathIdx(field, idx), this.idPrefix) : this.pathIdx(field, idx);
    },
    addPrimitiveArrayItem(field) {
      const newItem = this.ctx.createNewArrayItem ? this.ctx.createNewArrayItem(field) : (field.defaultValue ?? "");
      this.ctx.pushArrayItem(this.fullPath(field), newItem);
    },
    addGroupArrayItem(field) {
      const path = this.fullPath(field);
      const newItem = this.ctx.createNewArrayItem ? this.ctx.createNewArrayItem(field) : {};
      this.ctx.pushArrayItem(path, newItem);
    },
    isCalculated(path) {
      return this.ctx.isCalculatedField && this.ctx.isCalculatedField(path);
    },
    onAutoIncrementInput(field, val) {
      this.ctx.setValue(this.fullPath(field), val);
    },
    onInvoiceNumberPreview(isPreview) {
      if (!this.ctx || !this.ctx.setValue) return;
      if (isPreview) {
        this.ctx.setValue("_invoiceNumberPreview", true);
      } else if (this.ctx.setValue) {
        this.ctx.setValue("_invoiceNumberPreview", undefined);
      }
    },
    onSiblingInput(payload) {
      if (!payload || !this.ctx.setValue) return;
      const path = payload.path || payload.key;
      if (!path) return;
      this.ctx.setValue(path, payload.value != null ? payload.value : "");
    },
    localeValuesFor(field) {
      if (!isFieldTranslatable(field) || !this.ctx.getValue) return {};
      const base = this.fullPath(field);
      // Misma pasada de render que el value base (tras cargar el item)
      void this.ctx.getValue(base);
      const out = {};
      getFieldTranslatableLocales(field).forEach((code) => {
        const path = getLocaleSiblingPath(base, code);
        const v = this.ctx.getValue(path);
        out[code] = v != null ? String(v) : "";
      });
      return out;
    },
    onAutoIncrementEditingFields(v) {
      this.$emit("update:editingFields", v);
    },
    onAutoIncrementUpdateDateField(payload) {
      const path = this.basePath ? `${this.basePath}.${payload.fieldKey}` : payload.fieldKey;
      this.ctx.setValue(path, payload.value);
    },
    listOptionFilterFor(field) {
      if (!field || field.type !== "list" || !this.ctx.getListOptionFilterAllowedIds) {
        return undefined;
      }
      return this.ctx.getListOptionFilterAllowedIds(field.key);
    },
    recordItemAtCurrentPath() {
      if (!this.ctx.getValue) {
        return null;
      }
      if (!this.basePath) {
        return this.ctx.getState ? this.ctx.getState() : null;
      }
      const item = this.ctx.getValue(this.basePath);
      return item && typeof item === "object" ? item : null;
    },
  },
};
</script>

<!-- Sin scoped: hay que alcanzar los controles que renderizan los componentes Field*.
     Todo cuelga de .dyn-array-* , que solo emite este template. -->
<style>
/* Cabecera de cada sección: renglón fino con una sola línea de separación. */
.dyn-group-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0;
  font-size: 0.9rem;
  font-weight: 600;
}

.dyn-group-header .material-icons,
.dyn-group-header .group-icon.fas {
  font-size: 16px;
  line-height: 1;
  opacity: 0.65;
}

.dyn-array-block {
  margin-bottom: 0.35rem !important;
}

.dyn-array-title {
  margin-bottom: 0.25rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

/* La fila del ítem se lee como una fila de tabla: sin aire entre celdas y con
   una línea que separa un campo del siguiente, como en el PDF. */
.dyn-array-row {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  padding: 0;
  margin-bottom: 0.35rem;
  /* Sin overflow:hidden: recortaría el desplegable de list y reference. */
}

/* flex-shrink 0 a propósito: si no entran, que bajen de línea enteras en vez
   de apretarse hasta que no se lea nada. */
.dyn-array-cell {
  min-width: 0;
  flex: 0 0 auto;
  padding: 0.15rem 0.35rem;
  border-left: 1px solid #dee2e6;
}

.dyn-array-cell:first-child {
  border-left: 0;
}

/* Un grupo anidado no comparte línea: abre su propio bloque, separado por arriba. */
.dyn-array-cell--block {
  flex: 1 0 100%;
  border-left: 0;
  border-top: 1px solid #dee2e6;
}

/* Lo que lleva texto largo crece; lo numérico, las fechas y las listas se
   quedan chicas: una lista guarda una opción corta, no un párrafo. */
.dyn-array-cell--select,
.dyn-array-cell--string,
.dyn-array-cell--text {
  flex: 1 0 11rem;
  min-width: 7rem;
}

/* El reference se ancha con lo que tiene adentro (flex-basis auto) en vez de
   arrancar en 11rem: lo que guarda es el nombre de un registro, y ahí viene
   el talle y el packing del producto. Con la medida fija se leía «SEA FROZEN
   HEAD-ON SHELL-ON RAW RED SHRIMPS (Pleoticus Muelleri…» y el packing, que es
   lo que distingue una línea de la otra, quedaba afuera. El tope de 100% es
   el cinturón: si el nombre no entra en la fila, la celda se la queda entera
   y el texto sigue abajo, pero nunca desborda a lo ancho. */
.dyn-array-cell--reference {
  flex: 1 0 auto;
  min-width: 11rem;
  max-width: 100%;
}

.dyn-array-cell--number {
  flex: 0 0 6.5rem;
  min-width: 4.5rem;
}

/* El input date de Chrome no baja de ~132px por más que se le pida menos:
   en 6,5rem se salía de la celda y se montaba sobre la columna siguiente. */
.dyn-array-cell--date {
  flex: 0 0 9.5rem;
  min-width: 9.5rem;
}

/* Las listas no crecen como el texto, pero sí lo justo para que se lea
   "Select or type to add new..." sin cortarse. */
.dyn-array-cell--list {
  flex: 0 0 10.5rem;
  min-width: 7rem;
}

.dyn-array-cell-label,
.dyn-array-row .reference-head-label {
  display: block;
  margin-bottom: 0.05rem;
  font-size: 0.68rem;
  line-height: 1.1;
  color: #6c757d;
  white-space: nowrap;
}

/* «* required» al lado del nombre del campo, en el mismo renglón. */
.dyn-array-cell-label .text-danger {
  margin-left: 0.25rem;
  font-weight: 400;
}

/* Dentro de la fila manda el look de la tabla, no el del formulario largo.
   (El tamaño chico de los botones lo pone el propio campo reference.) */
.dyn-array-row .reference-head-label {
  font-size: 0.68rem;
  font-weight: 700;
  color: #6c757d;
}


.dyn-array-row-actions {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding: 0.15rem 0.35rem;
  border-left: 1px solid #dee2e6;
}

/* El contenedor que arma getContainerClass trae p-2: acá sobra. El max-width
   es el cinturón: nada se sale de su celda y se monta sobre la de al lado. */
.dyn-array-row .form-renderer-root > div {
  padding: 0 !important;
  margin-bottom: 0 !important;
  max-width: 100%;
}

/* La grilla de la tabla ya separa los campos: el recuadro de cada input sobra
   y sumaba un borde sobre otro. Se marca al pasar por encima y al editar. */
.dyn-array-row .form-control,
.dyn-array-row .form-select,
.dyn-array-row .multiselect__tags {
  min-height: 0;
  height: auto;
  padding: 0.2rem 0.3rem !important;
  font-size: 0.8rem;
  line-height: 1.35;
  border-color: transparent;
  background-color: transparent;
  border-radius: 2px;
}

.dyn-array-row .form-control:hover,
.dyn-array-row .form-select:hover,
.dyn-array-row .multiselect__tags:hover {
  border-color: #ced4da;
}

.dyn-array-row .form-control:focus,
.dyn-array-row .form-select:focus,
.dyn-array-row .multiselect--active .multiselect__tags {
  border-color: #86b7fe;
  background-color: #fff;
}

/* Los calculados ya venían en gris: que se siga notando que no se tocan. */
.dyn-array-row .form-control:disabled,
.dyn-array-row .form-control[readonly],
.dyn-array-row .readonly-field,
.dyn-array-row .calculated-field {
  background-color: #f1f3f5;
}

.dyn-array-row .multiselect,
.dyn-array-row .multiselect__single,
.dyn-array-row .multiselect__input,
.dyn-array-row .multiselect__placeholder {
  min-height: 0;
  margin-bottom: 0;
  padding: 0;
  font-size: 0.8rem;
  line-height: 1.35;
  background-color: transparent;
}

/* En una fila de tabla nada parte en dos renglones ni se mete en la celda de
   al lado: lo que no entra se corta. El desplegable cuelga de .multiselect,
   no de __tags, así que recortar acá no lo tapa. */
.dyn-array-row .multiselect__tags {
  overflow: hidden;
}

.dyn-array-row .multiselect__single,
.dyn-array-row .multiselect__placeholder {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Salvo en el reference, que ya se ancha con su contenido: recortar acá le
   sacaba el sentido, porque la celda mide lo que mide el nombre. Cuando el
   nombre es tan largo que la celda toca el tope de la fila, sigue en el
   renglón de abajo en vez de terminar en puntos suspensivos. */
.dyn-array-cell--reference .multiselect__tags {
  overflow: visible;
}

.dyn-array-cell--reference .multiselect__single {
  overflow: visible;
  white-space: normal;
  text-overflow: clip;
}

/* Mientras se edita se ensancha sobre las celdas vecinas: en 6,5rem no se lee
   ni el placeholder ni lo que uno escribe. Al cerrar vuelve a lo compacto. */
.dyn-array-row .multiselect--active {
  position: relative;
  z-index: 1000;
}

.dyn-array-row .multiselect--active .multiselect__tags {
  position: relative;
  z-index: 1;
  overflow: visible;
  min-width: 16rem;
  background-color: #fff;
  border-color: #86b7fe;
}

.dyn-array-row .form-group,
.dyn-array-row .input-group {
  margin-bottom: 0;
}

.dyn-array-row .btn-sm {
  padding: 0.1rem 0.35rem;
  line-height: 1;
}

.dyn-array-row .material-icons {
  font-size: 1rem;
  vertical-align: middle;
}
</style>
